<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

import { getBuildingSizeLabel } from '@/bundles/MeasurementUnits/helpers/format/getBuildingSizeFormatted';

export default Vue.extend({
  name: 'BuildingSizeLabel',

  functional: true,

  props: {
    value: {
      type: [String, Number],
      default: 0
    }
  },

  render (h: CreateElement, ctx: RenderContext): VNode {
    const value = ctx.props.value;
    const className = `${ctx.data.staticClass || ''} ${ctx.data.class || ''}`.trim();

    const label = getBuildingSizeLabel(value);

    if (!label) {
      return h('span', { class: `${className} na`.trim() }, 'N/A');
    }

    return h('span', { ...ctx.data, class: className || undefined }, label);
  }
});
</script>
